import { render, staticRenderFns } from "./form-credit-calculator.vue?vue&type=template&id=1bed8a65&"
import script from "./form-credit-calculator.vue?vue&type=script&lang=js&"
export * from "./form-credit-calculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangePeriod: require('/var/www/components/range/range-period.vue').default,RangePayment: require('/var/www/components/range/range-payment.vue').default})
